import { Button, Chip, InputAdornment, Stack, Typography } from "@mui/material";
import React, { useMemo } from "react";
import {
  CustomeDialog,
  CustomTable,
  DeleteModal,
  InputControl,
} from "../../../shared";
import AddIcon from "@mui/icons-material/Add";
import { createColumnHelper } from "@tanstack/react-table";
import { AddMemberDialog } from "./AddMemberDialog";
import { assignUsertoRoles } from "../api/RolesAndPermissionsApi";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

export const RoleMembersList = (prop) => {
  const {
    state,
    onDelete,
    confirmDeleteUser,
    resetDeleteInfo,
    deleteInfo,
    handleClickOpen,
    HandleFilterUsers,
    isSelectedUser,
    handleUsersSelect,
    handleAssignUser,
    handleSelectAll,
    usersListQuery,
    handleAssignUsers,
    isCreateVisible,
    isDeletable,
  } = prop;
  const columnHelper = createColumnHelper([]);
  const ActionButtons = ({ deleteAction }) => {
    return (
      <div className="action-buttons" onClick={(e) => e.preventDefault()}>
        {isDeletable && (
          <img
            alt="delete"
            onClick={deleteAction}
            src="/icons/ic_trash_sm.png"
            style={{ width: 20, height: 20 }}
          />
        )}
      </div>
    );
  };

  const columns = useMemo(
    () => [
      columnHelper.accessor("name", {
        header: () => "Name",
      }),
      columnHelper.accessor("email", {
        header: () => "Email",
      }),

      columnHelper.accessor("status", {
        header: () => "Status",
        cell: ({ row }) => {
          return row?.original.status ? (
            <Chip
              size="small"
              color="primary"
              variant="filled"
              label="ACTIVE"
            />
          ) : (
            <Chip size="small" color="gray" label="INACTIVE" />
          );
        },
      }),

      columnHelper.display({
        id: "actions",
        cell: (props) => {
          const { row } = props;
          return (
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
              gap="8px"
            >
              <ActionButtons deleteAction={(e) => onDelete(row.original.id)} />
            </Stack>
          );
        },
      }),
    ],
    []
  );
  return (
    <>
      <CustomTable
        defaultData={state.filteredMembersList ?? []}
        columns={columns}
        headerText="Admin Users"
        onRowLink={(e) => {
          return `/manage-users/details/${e.id}`;
        }}
        rightContent={
          isCreateVisible && (
            <Button
              type="button"
              size="medium"
              variant="outlined"
              color="gray2"
              startIcon={<AddIcon />}
              onClick={() => handleClickOpen(true)}
            >
              Member
            </Button>
          )
        }
        showSearchBar
        enableTableContainerPaddingBottom
        tableHeaderStyles={{
          p: 0,
          fontSize: "18px",
          fontWeight: 500,
          borderBottom: 1,
          borderColor: "divider",
        }}
      />

      <CustomeDialog
        open={state?.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: { width: { sm: "60vw", xs: "90%" }, height: "80vh" },
        }}
        title={
          <Stack
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            p="16px"
            borderBottom={1}
            borderColor="divider"
          >
            <Typography fontWeight={500} variant="body1" fontSize="20px">
              Add Members
            </Typography>
            <InputControl
              sx={{ width: "200px", borderRadius: "10px" }}
              type="table-search"
              placeholder="Search"
              value={state.userSearchText}
              size="small"
              startAdornment={
                <InputAdornment position="start">
                  <SearchIcon size="large" />
                </InputAdornment>
              }
              endAdornment={
                state.userSearchText && (
                  <InputAdornment
                    sx={{ cursor: "pointer" }}
                    onClick={() => {
                      HandleFilterUsers("search", "");
                    }}
                    position="end"
                  >
                    <CloseIcon size="large" />
                  </InputAdornment>
                )
              }
              fullWidth
              onChange={(e) => {
                HandleFilterUsers("search", e.target.value);
              }}
            />
          </Stack>
        }
        sx={{
          pl: "8px",
          height: "calc(80vh - 128px)",
          overflowX: "hidden",
          overflowY: "auto",
        }}
        content={
          <AddMemberDialog
            userList={state.filteredUsers}
            handleUsersSelect={handleUsersSelect}
            isSelectedUser={isSelectedUser}
            isSelectAllChecked={state?.filteredUsers?.every((item) =>
              state?.selectedUsers?.includes(item.id)
            )}
            onAllSelect={handleSelectAll}
            hasSelectAll={true}
            isSelected={(id) => state.selectedUsers.includes(id)}
            isLoading={
              usersListQuery?.isPending || assignUsertoRoles?.isPending
            }
          />
        }
        footer={{
          display: true,
          onConfirm: handleAssignUser,
          onCancel: () => handleClickOpen(false),
          isDisabled:
            state.selectedUsers.length === 0 || handleAssignUsers?.isPending,
        }}
      />
      <DeleteModal
        open={deleteInfo?.show}
        handleClose={() => resetDeleteInfo()}
        onConfirm={() => confirmDeleteUser()}
      />
    </>
  );
};
